import { Injectable } from '@angular/core';

import { DuplicateCheckArtifactInfo, DuplicateCheckTypeEntity } from '../../tracking/models/duplicate-check-type'
import { JsonHttpService } from '../../shared/http/json-http.service'
import { HttpParams } from '@angular/common/http';
import { DataFieldGroup } from '../../shared/datafields/models';

@Injectable({
    providedIn: 'root'
})
export class DuplicateCheckService {

    constructor(private httpService: JsonHttpService) { }

    getDuplicateCheckTypes(): Promise<DuplicateCheckTypeEntity[]> {
        return this.httpService.get('/api/tracking/duplicate-check/get-types').toPromise();
    }

    saveDuplicateCheckType(item: DuplicateCheckTypeEntity): Promise<DuplicateCheckTypeEntity> {
        return this.httpService.post('/api/tracking/duplicate-check/save-type', item).toPromise();
    }

    deleteDuplicateCheckType(id: number): Promise<void> {
        const options = { params: new HttpParams().set('duplicateCheckTypeId', `${id}`) };
        return this.httpService.post('/api/tracking/duplicate-check/delete-type', null, options).toPromise();
    }

    getDuplicateCheckArtifactInfo(artifactId: string): Promise<DuplicateCheckArtifactInfo> {
        const options = { params: new HttpParams().set('artifactId', artifactId) };
        return this.httpService.get('/api/tracking/duplicate-check/get-artifact-info', options).toPromise();
    }

    getDuplicateCheckDataFieldGroups(artifactId: string, duplicateCheckConfigurationId?: number): Promise<DataFieldGroup[]> {
        const options = { params: new HttpParams().set('artifactId', artifactId) };
        if (duplicateCheckConfigurationId) {
            options.params = options.params.set('duplicateCheckConfigurationId', duplicateCheckConfigurationId);
        }
        return this.httpService.get('/api/tracking/duplicate-check/get-datafields', options).toPromise();
    }
}
